import React from 'react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { X, Type, History, Maximize2, Minimize2, Eraser } from 'lucide-react';

/**
 * ChatHeader component
 * Header for the chat sidebar with controls for sessions, font size, expand/collapse
 */
const ChatHeader = ({
  sessions,
  showSessionList,
  setShowSessionList,
  fontSize,
  setFontSize,
  onToggleSize,
  isExpanded,
  onClose,
  onClear,
  newSessionControl,
  contextControl,
  reasoningTemplateControl,
}) => {
  return (
    // Hallazgo del dueño: en anchos chicos los controles desbordaban y el botón
    // de cerrar (el último) quedaba fuera de vista. El título trunca y los
    // controles hacen wrap, así la X SIEMPRE es visible.
    <div className="p-4 border-b border-white/20 flex justify-between items-center gap-2 flex-shrink-0">
      <h2 className="font-semibold text-lg select-none truncate min-w-0" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        Chat IA
      </h2>
      <div className="flex items-center gap-2 flex-wrap justify-end">
        {/* T-180: orden del toolbar — [Nuevo] [Historial] [Limpiar] | [Contexto ▾] | [Plantilla] …resto */}
        {newSessionControl}

        {/* Historial: read-only archived conversations. */}
        <Button
          data-testid="history-button"
          variant="ghost"
          size="sm"
          onClick={() => setShowSessionList(!showSessionList)}
          className="hover:bg-white/50 dark:hover:bg-slate-700/50 relative"
          title="Historial de conversaciones"
        >
          <History className="w-4 h-4" />
          <span className="hidden sm:inline text-[10px]">Historial</span>
        </Button>

        {/* Limpiar chat: archive the current conversation to the history.
            T9: ahora pide confirmación (onClear sólo abre el ConfirmDialog). */}
        <Button
          data-testid="clear-chat-button"
          variant="ghost"
          size="sm"
          onClick={onClear}
          className="hover:bg-white/50 dark:hover:bg-slate-700/50"
          title="Limpiar chat (se guarda en el historial)"
        >
          <Eraser className="w-4 h-4" />
          <span className="hidden sm:inline text-[10px]">Limpiar</span>
        </Button>

        {/* Separador grupo 1 | grupo 2 */}
        <div className="w-px h-5 bg-white/20 dark:bg-slate-600 mx-1" />

        {/* T-180: menú Contexto unificado (modo + conversación + memoria). */}
        {contextControl}

        {/* Separador grupo 2 | grupo 3 */}
        <div className="w-px h-5 bg-white/20 dark:bg-slate-600 mx-1" />

        {/* T-174: plantilla de razonamiento por sesión. */}
        {reasoningTemplateControl}

        {/* Font Size Selector */}
        <Select value={fontSize} onValueChange={setFontSize}>
          <SelectTrigger className="w-20 h-8 text-xs" data-testid="font-size-select">
            <div className="flex items-center gap-1">
              <Type className="w-3 h-3" />
              <SelectValue />
            </div>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="10px">10px</SelectItem>
            <SelectItem value="12px">12px</SelectItem>
            <SelectItem value="14px">14px</SelectItem>
          </SelectContent>
        </Select>

        {onToggleSize && (
          <Button
            data-testid="toggle-size-button"
            variant="ghost"
            size="sm"
            onClick={onToggleSize}
            className="hover:bg-white/50 dark:hover:bg-slate-700/50"
            title={isExpanded ? "Tamaño normal" : "Expandir chat"}
          >
            {isExpanded ? (
              <Minimize2 className="w-4 h-4" />
            ) : (
              <Maximize2 className="w-4 h-4" />
            )}
          </Button>
        )}
        <Button
          data-testid="close-chat-button"
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="hover:bg-white/50 dark:hover:bg-slate-700/50"
          title="Cerrar"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default ChatHeader;
